import * as React from "react"

const DEFAULT_RANGE_LIMIT = 6

export default class YearsFormPart extends React.Component<Props, State> {
	render() {
		return <div className="field">
				<label className="label" htmlFor={this.props.startInputName}>
					Années
				</label>

				<div className="field-body">
					<div className="field">
						<p className="control">
							<input
							className="input"
							id={this.props.startInputName}
							name={this.props.startInputName}
							placeholder="De"
							title="Année de départ"
							type="number"
							value={this.props.start}
							onChange={e => this.handleChange(e, "start")} />
						</p>
					</div>

					<div className="field">
						<p className="control">
							<input
							className="input"
							name={this.props.endInputName}
							placeholder="à"
							title="Année de fin"
							type="number"
							value={this.props.end}
							onChange={e => this.handleChange(e, "end")} />
						</p>
					</div>
				</div>

				{this.yearsCount > this.rangeLimit &&
					<p className="help">{this.rangeLimitMessage}</p>}
			</div>

	}

	private get yearsCount(): number {
		return this.props.end - this.props.start
	}

	private get rangeLimit(): number {
		return (this.props.rangeLimit || 0 === this.props.rangeLimit)
		? this.props.rangeLimit : DEFAULT_RANGE_LIMIT
	}

	private get rangeLimitMessage(): React.ReactNode {
		const defaultMessage = `Il est conseillé de ne pas générer plus de {0}
		années ({1} actuellement) pour ne pas altérer le rendu des tableaux.`

		const message = this.props.rangeLimitMessage || defaultMessage

		return message
		.replace("{0}", this.rangeLimit.toString())
		.replace("{1}", this.yearsCount.toString())
	}

	private handleChange(
		e: React.ChangeEvent<HTMLInputElement>,
		limit: Limit
	): void {
		const year = parseInt(e.target.value)
		this.props.onChange(year, limit)
	}
}

export interface Props {
	/**
	 * Nom du champ de l'année de départ (attribut `name`)
	 */
	startInputName: string
	/**
	 * Nom du champ de l'année de fin (attribut `name`)
	 */
	endInputName: string
	/**
	 * Année de fin
	 */
	end: number
	/**
	 * Année de début
	 */
	start: number
	/**
	 * Nombre d'années maximum conseillé. Par défaut `6`.
	 */
	rangeLimit?: number
	/** Message à afficher lorsque le nombre d'années maximum conseillé
	 * (`rangeLimit`) a été dépassé.
	 *
	 * Cette chaîne de caractères peut recevoir deux paramètres de formattage :
	 * - `{0}`: Le nombre d'années maximum conseillé (valeur de `rangeLimit`)
	 * - `{1}`: Le nombre d'années générées.
	 *
	 * Par defaut `"Il est conseillé de ne pas générer plus de {0} années ({1}
	 * actuellement) pour ne pas altérer le rendu des tableaux."`
	 */
	rangeLimitMessage?: string

	onChange(year: number, limit: Limit): void
}

interface State {}

type Limit = "end" | "start"



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/years-form-part/index.tsx